export default __webpack_public_path__ + "static/illustration-desc.url-a4e1de4f0d7fa46cbd37834f86a83012.svg";